;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { CREDENTIAL_PROFESSIONAL_ROLES } from "../constants"
import find from "lodash/find"

/**
 * Gets the display name for a credential role code
 * @param {string} roleCode - The role code to look up
 * @returns {string} The display name for the role, or the original code if not found
 */
export const getRoleDisplay = (roleCode) => {
  //   console.log("getRoleDisplay roleCode", roleCode, CREDENTIAL_PROFESSIONAL_ROLES)
  if (!roleCode) return ""

  // Find the role object that matches the short code
  const roleObj = find(CREDENTIAL_PROFESSIONAL_ROLES, { shortEnum: roleCode })

  const roleObjShortDisp = find(CREDENTIAL_PROFESSIONAL_ROLES, {
    shortDisplay: roleCode,
  })
  const finalRoleObj = roleObj ? roleObj : roleObjShortDisp

  //   console.log("roleObj", roleObj, roleObjShortDisp, finalRoleObj    )
  // If found, return the long description, otherwise return the original role code
  return finalRoleObj ? finalRoleObj.long : roleCode
}
